import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ts-auto-mock/ts-auto-mock/ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "register-mock"
    }}>{`Register mock`}</h1>
    <p><inlineCode parentName="p">{`registerMock`}</inlineCode>{` will register your custom mock that will be re-used automatically whenever another mock is identified as converting the same interface.`}</p>
    <h4 {...{
      "id": "personts"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`./person.ts`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`export interface Person {
  id: string;
}
`}</code></pre>
    <h4 {...{
      "id": "person-fakets"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`./person-fake.ts`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { Person } from './person';

export class PersonFake extends Person {
  public id: string;
  public name: string;

  constructor() {
    this.id = "Basic Id";
    this.name = "Basic name";
  }
}
`}</code></pre>
    <h4 {...{
      "id": "contextts"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`./context.ts`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-ts",
        "metastring": "context.ts",
        "context.ts": true
      }}>{`import { registerMock } from 'ts-auto-mock';
import { Person } from './person';
import { PersonFake } from './person-fake';

registerMock<Person>(() => new PersonFake());
`}</code></pre>
    <h4 {...{
      "id": "my-testts"
    }}><strong parentName="h4"><inlineCode parentName="strong">{`./my-test.ts`}</inlineCode></strong></h4>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface Wrapper {
  person: Person;
}

const mock: Wrapper = createMock<Wrapper>();
mock.person // PersonFake
mock.person.id // "Basic Id"
mock.person.name // "Basic name"
`}</code></pre>
    <p>{`When injecting fake (/stubbed) implementations, we recommend using the `}<a parentName="p" {...{
        "href": "./extension"
      }}>{`extension strategy`}</a>{` to retrieve the faked object.`}</p>
    <p>{`An example of usage for Promise->FakePromise can be found in `}<a parentName="p" {...{
        "href": "https://github.com/Typescript-TDD/ts-auto-mock/blob/master/test/registerMock/extensionStrategy/extensionStrategy.test.ts"
      }}>{`the test folder`}</a>{`.`}</p>
    <p><strong parentName="p">{`Note:`}</strong>{` You can only use it in a common file (webpack context.ts, mocha tsnode.js, etc), using `}<inlineCode parentName="p">{`registerMock`}</inlineCode>{` in other files will give unexpected results.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      